import { fetchCurrentUser, loadUserSubscriptions } from '../../ducks/user.duck';
import { storableError } from '../../util/errors';
// You need to implement fetchAllSubscriptionsApi in src/util/api.js
import { fetchAllSubscriptionsApi, fetchAllTokenpackageApi } from '../../util/api';

// ================ Action types ================ //
export const FETCH_TOKEN_PACKAGES_REQUEST = 'app/TokenPackagesPage/FETCH_TOKEN_PACKAGES_REQUEST';
export const FETCH_TOKEN_PACKAGES_SUCCESS = 'app/TokenPackagesPage/FETCH_TOKEN_PACKAGES_SUCCESS';
export const FETCH_TOKEN_PACKAGES_ERROR = 'app/TokenPackagesPage/FETCH_TOKEN_PACKAGES_ERROR';

// ================ Reducer ================ //
const initialState = {
  fetchInProgress: false,
  fetchError: null,
  tokenPackages: [],
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_TOKEN_PACKAGES_REQUEST:
      return { ...state, fetchInProgress: true, fetchError: null };
    case FETCH_TOKEN_PACKAGES_SUCCESS:
      return { ...state, fetchInProgress: false, tokenPackages: payload.data, fetchError: null };
    case FETCH_TOKEN_PACKAGES_ERROR:
      return { ...state, fetchInProgress: false, fetchError: payload };
    default:
      return state;
  }
}

// ================ Action creators ================ //
export const fetchTokenPackagesRequest = () => ({ type: FETCH_TOKEN_PACKAGES_REQUEST });
export const fetchTokenPackagesSuccess = data => ({ type: FETCH_TOKEN_PACKAGES_SUCCESS, payload: data });
export const fetchTokenPackagesError = e => ({ type: FETCH_TOKEN_PACKAGES_ERROR, payload: e, error: true });

export const onFetchTokenPackage = params => (dispatch, getState, sdk) => {
  dispatch(fetchTokenPackagesRequest());
  return fetchAllTokenpackageApi({})
    .then(tokenPackages => {
      dispatch(fetchTokenPackagesSuccess(tokenPackages));
      return tokenPackages;
    })
    .catch(e => {
      dispatch(fetchTokenPackagesError(storableError(e)));
      throw e;
    });
};

// ================ Thunk ================ //
export const loadData = (params) => async (dispatch, getState, sdk) => {
  dispatch(fetchTokenPackagesRequest());

  try {
    await dispatch(fetchCurrentUser());
    const currentUser = getState().user.currentUser;
    const userId = currentUser?.id?.uuid;

    if (!userId) {
      throw new Error('User ID not found');
    }

    await dispatch(loadUserSubscriptions({ userId }));
    await dispatch(onFetchTokenPackage());

    return {};
  } catch (e) {
    dispatch(fetchTokenPackagesError(storableError(e)));
    return {};
  }
};
